import { render, staticRenderFns } from "./AwardListComponent.vue?vue&type=template&id=29296251&"
import script from "./AwardListComponent.vue?vue&type=script&lang=js&"
export * from "./AwardListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports